(() => {
  'use strict';
  const routes = window.woowRoutes || { cart: '/cart', add: '/cart/add', change: '/cart/change' };
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const state = { overlay: null, opener: null, cartBusy: false };
  const focusable = '[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]';
  const announce = (message) => { const live = document.querySelector('[data-woow-announcer]'); if (live) live.textContent = message; };
  function rememberPromotion(overlay) {
    const key = overlay?.dataset.promotionStorageKey;
    if (key) { try { localStorage.setItem(key, '1'); } catch (_) {} }
  }
  async function copyCoupon(button) {
    const code = button.dataset.copyCoupon;
    const overlay = button.closest('[data-promotion]');
    const label = button.querySelector('[data-copy-coupon-label]');
    const status = overlay?.querySelector('[data-coupon-status]');
    if (!code) return;
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(code);
      if (label) label.textContent = 'Copied!';
      if (status) status.textContent = 'Code copied. Enter it at checkout if you wish.';
    } catch (_) {
      const codeNode = button.querySelector('[data-coupon-code]');
      if (codeNode) { const range = document.createRange(); range.selectNodeContents(codeNode); const selection = window.getSelection(); selection?.removeAllRanges(); selection?.addRange(range); }
      if (status) status.textContent = 'Please copy the selected code and enter it at checkout if you wish.';
    }
  }
  function updatePricePresentation(scope, variant) {
    const row = scope.querySelector('[data-woow-price]');
    const price = row?.querySelector('[data-price-money]') || scope.querySelector('[data-product-price]');
    if (price) price.textContent = variant.price || '';
    const compare = row?.querySelector('[data-price-compare]') || scope.querySelector('[data-product-compare]');
    const priceCents = Number(variant.priceCents);
    const compareCents = Number(variant.compareCents);
    const hasComparison = Number.isFinite(priceCents) && Number.isFinite(compareCents) && compareCents > priceCents && !!variant.compare;
    if (compare) {
      compare.textContent = variant.compare || '';
      compare.hidden = !hasComparison;
      compare.title = variant.compareTitle || '';
      if (variant.compareAria) compare.setAttribute('aria-label', variant.compareAria); else compare.removeAttribute('aria-label');
    }
    const badge = row?.querySelector('[data-price-saving]');
    const percent = row?.querySelector('[data-price-percent]');
    const difference = hasComparison ? Math.round((compareCents - priceCents) * 100 / compareCents) : 0;
    if (badge) {
      badge.hidden = !hasComparison || difference <= 0;
      badge.title = variant.compareTitle || '';
      badge.setAttribute('aria-label', `${difference}% below ${variant.compareAria || 'the comparison price'}`);
    }
    if (percent) percent.textContent = String(difference);
    const couponNote = row?.querySelector('[data-price-coupon-note]');
    const couponCode = row?.querySelector('[data-price-code]');
    const beforeCoupon = row?.querySelector('[data-price-before-coupon-money]');
    if (couponNote) couponNote.hidden = !variant.couponCode;
    if (couponCode) couponCode.textContent = variant.couponCode ? `with ${variant.couponCode}` : '';
    if (beforeCoupon) beforeCoupon.textContent = variant.beforeCouponPrice || '';
    if (row) { row.dataset.priceCents = String(priceCents); row.dataset.beforeCouponCents = String(variant.beforeCouponCents || priceCents); row.dataset.couponCode = variant.couponCode || ''; }
  }
  function updateInventoryPresentation(section, variant) {
    const status = section.querySelector('[data-product-inventory]');
    const text = status?.querySelector('[data-inventory-text]');
    if (!status || !text) return;
    const tracked = variant.inventoryTracked === true;
    const quantity = tracked ? Number(variant.inventoryQuantity) : null;
    const reliableQuantity = tracked && Number.isFinite(quantity);
    let state = 'available';
    let message = 'In stock';
    if (!variant.available) {
      state = 'unavailable';
      message = reliableQuantity && quantity <= 0 ? 'Sold out — 0 pairs in stock for this size' : 'Unavailable for this size';
    } else if (reliableQuantity && quantity > 0) {
      message = `In stock — ${quantity} ${quantity === 1 ? 'pair' : 'pairs'} for this size`;
    } else if (reliableQuantity) {
      state = 'orderable';
      message = 'Available to order';
    }
    status.classList.remove('woow-inventory--available', 'woow-inventory--unavailable', 'woow-inventory--orderable');
    status.classList.add(`woow-inventory--${state}`);
    text.textContent = message;
  }
  function selectedFormVariant(form) {
    const select = form.querySelector('[data-variant-select]');
    const section = form.closest('[data-woow-product]');
    const data = section?.querySelector('[data-product-variants]');
    if (select && data) {
      try { return JSON.parse(data.textContent).find((variant) => String(variant.id) === select.value); } catch (_) {}
    }
    const option = select?.options[select.selectedIndex];
    return option ? { available: option.dataset.available !== 'false' } : null;
  }
  function restoreAddButton(form, add, fallbackLabel) {
    const selected = selectedFormVariant(form);
    const available = selected ? selected.available : true;
    const busy = form.dataset.woowSubmitting === 'true';
    add.disabled = !available || busy;
    add.textContent = available ? (busy ? 'Adding…' : add.dataset.addLabel || add.dataset.availableLabel || fallbackLabel) : (add.dataset.addLabel ? 'SOLD OUT' : 'Sold out');
  }
  function closeDrawer() {
    if (!state.overlay) return;
    if (state.overlay.matches('[data-promotion]')) rememberPromotion(state.overlay);
    state.overlay.hidden = true;
    document.body.classList.remove('woow-lock');
    document.querySelectorAll('[aria-expanded="true"][data-drawer-open]').forEach((item) => item.setAttribute('aria-expanded', 'false'));
    if (state.opener && state.opener.isConnected) state.opener.focus();
    state.overlay = null;
  }
  function openDrawer(id, opener) {
    const overlay = document.getElementById(id);
    if (!overlay) return false;
    if (state.overlay) closeDrawer();
    state.overlay = overlay;
    state.opener = opener || document.activeElement;
    overlay.hidden = false;
    document.body.classList.add('woow-lock');
    if (opener && opener.hasAttribute('aria-expanded')) opener.setAttribute('aria-expanded', 'true');
    const target = overlay.querySelector('input[type="search"]') || overlay.querySelector('[role="dialog"]');
    if (target) target.focus();
    return true;
  }
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((item) => { item.textContent = String(count); item.classList.toggle('woow-hidden', count === 0); });
  }
  async function refreshCart(open) {
    const response = await fetch(`${routes.cart}?section_id=woow-cart-drawer`, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!response.ok) throw new Error('Your bag could not be refreshed. Please open the bag page.');
    const html = await response.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.getElementById('WoowCart');
    const previous = document.getElementById('WoowCart');
    if (!fresh || !previous) throw new Error('Your bag could not be refreshed. Please open the bag page.');
    const wasOpen = !!state.overlay && state.overlay.id === 'WoowCart';
    previous.replaceWith(fresh);
    updateCartCount(Number(fresh.dataset.itemCount || 0));
    if (wasOpen) {
      state.overlay = fresh;
      fresh.hidden = false;
      const dialog = fresh.querySelector('[role="dialog"]');
      if (dialog) dialog.focus();
    } else if (open) openDrawer('WoowCart', document.querySelector('[data-cart-open]'));
    return fresh;
  }
  function cartError(message) {
    const error = state.overlay?.querySelector('[data-cart-error]') || document.querySelector('#MainContent [data-cart-error]') || document.querySelector('#WoowCart [data-cart-error]');
    if (error) error.textContent = message;
    announce(message);
  }
  async function checkoutCart(link) {
    if (state.cartBusy) { cartError('Please wait while your bag is updated.'); return; }
    const form = link.closest('form');
    if (!form || !form.reportValidity()) return;
    state.cartBusy = true;
    link.setAttribute('aria-busy', 'true');
    try {
      let cart;
      const quantities = Array.from(form.querySelectorAll('input[name="updates[]"]'));
      // change.js validates stock. Process backwards so removing a row cannot
      // change the line numbers of the rows still waiting to be saved.
      for (let index = quantities.length - 1; index >= 0; index -= 1) {
        const input = quantities[index];
        const quantity = Number(input.value);
        if (quantity === Number(input.getAttribute('value'))) continue;
        if (!Number.isInteger(quantity) || quantity < 0) throw new Error('Please enter a valid quantity.');
        const response = await fetch(`${routes.change}.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: index + 1, quantity }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'This quantity is unavailable.');
        cart = result;
      }
      const note = form.querySelector('[name="note"]');
      if (note) {
        const response = await fetch(`${routes.update}.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: note.value }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Your order note could not be saved.');
        cart = result;
      }
      location.assign(cart && cart.item_count === 0 ? routes.cart : link.href);
    } catch (error) { cartError(error.message); }
    finally { state.cartBusy = false; link.removeAttribute('aria-busy'); }
  }
  async function changeCart(key, quantity) {
    if (state.cartBusy) return;
    state.cartBusy = true;
    const overlay = document.getElementById('WoowCart');
    if (overlay) overlay.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${routes.change}.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'The quantity could not be changed.');
      await refreshCart(false);
      announce('Shopping bag updated.');
    } catch (error) {
      try { await refreshCart(false); } catch (_) {}
      cartError(error.message);
    }
    finally { state.cartBusy = false; const current = document.getElementById('WoowCart'); if (current) current.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', (event) => {
    const checkout = event.target.closest('[data-cart-checkout]');
    if (checkout) { event.preventDefault(); checkoutCart(checkout); return; }
    const copy = event.target.closest('[data-copy-coupon]');
    if (copy) { event.preventDefault(); copyCoupon(copy); return; }
    const close = event.target.closest('[data-drawer-close]');
    if (close) { event.preventDefault(); closeDrawer(); return; }
    const trigger = event.target.closest('[data-drawer-open]');
    if (trigger) { event.preventDefault(); openDrawer(trigger.dataset.drawerOpen, trigger); return; }
    const search = event.target.closest('[data-search-open]');
    if (search && openDrawer('WoowSearch', search)) { event.preventDefault(); return; }
    const cart = event.target.closest('[data-cart-open]');
    if (cart && openDrawer('WoowCart', cart)) { event.preventDefault(); return; }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove && !state.cartBusy) { event.preventDefault(); changeCart(remove.dataset.cartKey, 0); return; }
    const minus = event.target.closest('[data-quantity-decrease]');
    const plus = event.target.closest('[data-quantity-increase]');
    if (minus || plus) {
      const control = (minus || plus).closest('[data-woow-quantity]');
      const input = control && control.querySelector('[data-quantity-input]');
      if (!input || state.cartBusy && input.matches('[data-cart-quantity]')) return;
      event.preventDefault();
      const min = input.min === '' ? 1 : Number(input.min);
      const max = input.max === '' ? Infinity : Number(input.max);
      const step = Number(input.step) || 1;
      const value = Number(input.value) || min;
      input.value = String(Math.min(max, Math.max(min, value + (plus ? step : -step))));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('keydown', (event) => {
    if (!state.overlay) return;
    if (event.key === 'Escape') { event.preventDefault(); closeDrawer(); }
    if (event.key === 'Tab') {
      const items = Array.from(state.overlay.querySelectorAll(focusable)).filter((item) => item.offsetParent !== null);
      if (!items.length) { event.preventDefault(); return; }
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !items.includes(document.activeElement))) { event.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (input.matches('[data-cart-quantity]')) {
      const value = Number(input.value);
      if (Number.isInteger(value) && value >= 0) changeCart(input.dataset.cartKey, value);
      return;
    }
    if (input.matches('[data-auto-submit]')) input.form.requestSubmit();
    if (input.matches('[data-variant-select]')) {
      const section = input.closest('[data-woow-product]');
      if (!section) {
        const form = input.form;
        const option = input.options[input.selectedIndex];
        const feature = form && form.closest('.woow-feature');
        if (!feature || !option) return;
        const submit = form.querySelector('[data-product-submit]');
        updatePricePresentation(feature, { price: option.dataset.price, compare: option.dataset.comparePrice, priceCents: option.dataset.priceCents, compareCents: option.dataset.compareCents, compareTitle: option.dataset.compareTitle, compareAria: option.dataset.compareAria, beforeCouponPrice: option.dataset.beforeCouponPrice, beforeCouponCents: option.dataset.beforeCouponCents, couponCode: option.dataset.couponCode });
        if (submit) { submit.dataset.availableLabel ||= 'Add to cart'; restoreAddButton(form, submit, submit.dataset.availableLabel); }
        return;
      }
      const data = section.querySelector('[data-product-variants]');
      if (!data) return;
      const variant = JSON.parse(data.textContent).find((item) => String(item.id) === input.value);
      if (!variant) return;
      updatePricePresentation(section, variant);
      updateInventoryPresentation(section, variant);
      const add = section.querySelector('[data-product-add]');
      if (add) restoreAddButton(input.form, add, 'ADD TO CART');
      const quantity = section.querySelector('[data-quantity-input]');
      if (quantity) { quantity.min = variant.min; quantity.step = variant.step; quantity.value = variant.min; if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max'); }
      if (variant.media) { const media = section.querySelector(`[data-product-media="${variant.media}"]`); if (media) media.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'nearest' }); }
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    }
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('[data-woow-product-form]')) return;
    if (form.dataset.woowSubmitting === 'true') { event.preventDefault(); return; }
    if (event.submitter && event.submitter.name !== 'add') return;
    const add = form.querySelector('[name="add"]');
    if (!add || add.disabled) return;
    event.preventDefault();
    const error = form.querySelector('[data-product-error]');
    if (error) { error.textContent = ''; error.hidden = true; }
    const previousText = add.textContent;
    add.dataset.availableLabel ||= add.dataset.addLabel || previousText;
    form.dataset.woowSubmitting = 'true';
    add.disabled = true; add.textContent = 'Adding…';
    try {
      const response = await fetch(`${routes.add}.js`, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'This item could not be added.');
      try { await refreshCart(true); }
      catch (_) { location.assign(routes.cart); return; }
      announce('Item added to your bag.');
    } catch (failure) { if (error) { error.textContent = failure.message; error.hidden = false; } else announce(failure.message); }
    finally { delete form.dataset.woowSubmitting; restoreAddButton(form, add, previousText); }
  });
  function setupHero(hero) {
    if (hero.dataset.woowReady) return;
    const track = hero.querySelector('[data-hero-track]');
    const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
    if (!track || !slides.length) return;
    hero.dataset.woowReady = 'true';
    let index = 0;
    let paused = false;
    const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
    const update = () => { dots.forEach((dot, position) => { dot.classList.toggle('is-active', position === index); dot.setAttribute('aria-current', String(position === index)); dot.setAttribute('aria-label', `Go to slide ${position + 1}${position === index ? ', current slide' : ''}`); }); };
    const go = (target) => { index = (target + slides.length) % slides.length; track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: reducedMotion ? 'instant' : 'smooth' }); update(); };
    hero.querySelector('[data-hero-prev]')?.addEventListener('click', () => go(index - 1));
    hero.querySelector('[data-hero-next]')?.addEventListener('click', () => go(index + 1));
    dots.forEach((dot, position) => dot.addEventListener('click', () => go(position)));
    track.addEventListener('scroll', () => { index = slides.reduce((best, slide, position) => Math.abs(slide.offsetLeft - slides[0].offsetLeft - track.scrollLeft) < Math.abs(slides[best].offsetLeft - slides[0].offsetLeft - track.scrollLeft) ? position : best, 0); update(); }, { passive: true });
    hero.addEventListener('mouseenter', () => { paused = true; }); hero.addEventListener('mouseleave', () => { paused = false; });
    hero.addEventListener('focusin', () => { paused = true; }); hero.addEventListener('focusout', () => { paused = false; });
    if (!reducedMotion && hero.dataset.autoplay !== 'false') { const timer = setInterval(() => { if (!hero.isConnected) { clearInterval(timer); return; } if (!paused && !document.hidden && hero.getBoundingClientRect().bottom > 0) go(index + 1); }, Math.max(3, Number(hero.dataset.autoplaySeconds) || 6.5) * 1000); }
    update();
  }
  function setupCarousel(carousel) {
    if (carousel.dataset.woowReady) return;
    const track = carousel.querySelector('[data-carousel-track]');
    if (!track) return;
    carousel.dataset.woowReady = 'true';
    const items = Array.from(track.querySelectorAll('[data-carousel-item]'));
    const previous = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const count = carousel.querySelector('[data-carousel-count]');
    const step = () => items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
    const move = (direction) => track.scrollBy({ left: step() * direction, behavior: reducedMotion ? 'instant' : 'smooth' });
    previous?.addEventListener('click', () => move(-1)); next?.addEventListener('click', () => move(1));
    const update = () => { if (previous) previous.disabled = track.scrollLeft < 2; if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; if (count && items.length) count.textContent = `${Math.min(items.length, Math.max(1, Math.round(track.scrollLeft / Math.max(1, step())) + 1))} / ${items.length}`; };
    track.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();
  }
  function initialize(scope = document) {
    scope.querySelectorAll('[data-woow-hero]').forEach(setupHero);
    scope.querySelectorAll('[data-woow-carousel]').forEach(setupCarousel);
  }
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  const promotion = document.querySelector('[data-promotion]');
  if (promotion && !window.Shopify?.designMode) { let dismissed = false; try { dismissed = localStorage.getItem(promotion.dataset.promotionStorageKey) === '1'; } catch (_) {} if (!dismissed) setTimeout(() => { if (!state.overlay) openDrawer(promotion.id); }, 5000); }
})();
